import APIService from './APIService';
import CacheService from './CacheService';

// Auth service placeholder
class AuthService {
  static async signup(username, email, password) {
    await APIService.signup(username, email, password)
  }

  static async login(username, password) {
    const response = await APIService.login(username, password)
    const user = { id: response.userId, username: response.userName, email: response.email };

    // Store user data in localStorage
    localStorage.setItem('user', JSON.stringify(user));

    return {
      token: response.idToken,
      user: user
    };
  }

  static async googleLogin(googleAccessToken) {
    // Exchange Google access token with backend — requires REACT_APP_GOOGLE_CLIENT_ID
    const response = await APIService.googleLogin(googleAccessToken);
    const user = { id: response.userId, username: response.userName, email: response.email };
    localStorage.setItem('user', JSON.stringify(user));
    return { token: response.idToken, user };
  }

  static async logout() {
    // Clear all authentication tokens and user data
    localStorage.removeItem('authToken');
    localStorage.removeItem('authTokenExpiresAt');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('refreshTokenExpiresAt');
    localStorage.removeItem('userId');
    localStorage.removeItem('isDebugger');
    localStorage.removeItem('user');

    // Clear all cached API responses to prevent data leakage
    CacheService.clear();
  }

  static isAuthenticated() {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return false;
    }

    // Check if token has expired
    const expiresAt = localStorage.getItem('authTokenExpiresAt');
    if (expiresAt && Date.now() >= parseInt(expiresAt)) {
      // Token has expired, clear it
      this.logout();
      return false;
    }

    return true;
  }

  static getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  /**
   * Checks if the refresh token is still valid.
   * @returns {boolean} True if refresh token exists and hasn't expired.
   */
  static hasValidRefreshToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      return false;
    }

    const refreshTokenExpiresAt = localStorage.getItem('refreshTokenExpiresAt');
    if (refreshTokenExpiresAt && Date.now() >= parseInt(refreshTokenExpiresAt)) {
      return false;
    }

    return true;
  }

  /**
   * Attempts to refresh the access token using the refresh token.
   * @returns {Promise<boolean>} True if refresh was successful.
   */
  static async refreshAccessToken() {
    if (!this.hasValidRefreshToken()) {
      return false;
    }

    try {
      const username = this.getUser()?.username;
      const refreshToken = localStorage.getItem('refreshToken');

      if (!username || !refreshToken) {
        return false;
      }

      // Use the login endpoint with refresh token
      await APIService.login(username, null, refreshToken);
      return true;
    } catch (error) {
      console.error('Token refresh failed:', error);
      this.logout();
      return false;
    }
  }
}

export default AuthService;